module.exports = __webpack_public_path__ + "static/img/ent-detail-99.a8dca03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-99.jpg
// module id = jW2U
// module chunks = 52